import { useParams } from 'react-router-dom';
import { createRoute, useEntityUrl } from 'framework/routing';

export const LEAVE_BALANCES_PATH = '/balances/list';
export const LEAVE_PATH = '/leaves';

export const useLeaveRoute = () => createRoute({ listRoute: LEAVE_PATH });

export const useLeaveUrl = () => useEntityUrl({ baseLink: LEAVE_PATH });

export const useLeaveId = () => useParams<Dictionary<string>>().id!;
